/**
 * バックエンドのエラーメッセージをユーザーフレンドリーなメッセージに変換する
 */
export const formatErrorMessage = (backendError: {
  title?: string;
  detail?: string;
  reason?: string;
  code?: string;
  callableStartHour?: number;
  callableEndHour?: number;
  validationErrors?: {
    path: string;
    message: string;
    code: string;
  }[];
}): string => {
  const { title, detail, reason, validationErrors, callableStartHour, callableEndHour } = backendError;

  // Call Not Allowed エラー (422)
  if (title === 'Call Not Allowed') {
    switch (reason) {
      case 'AGE_DIFFICULTY':
        return 'こちらの応募者は架電対象外です。（年齢条件）';
      case 'PERSON_DIFFICULTY':
        return 'こちらの応募者は架電対象外です。(人物難)';
      case 'ALREADY_APPLIED':
        return '既に予約済みか、1年以内に登録会に参加済みです。';
      case 'ALREADY_REQUESTED_CALL':
        return 'こちらの応募者は既に架電依頼済みです。';
      case 'OUTSIDE_CALLABLE_TIME':
        if (callableStartHour != null && callableEndHour != null) {
          return `現在は架電可能時間外です。架電可能な時間は${String(callableStartHour)}時～${String(callableEndHour)}時です。`;
        }
        return '現在は架電可能時間外です。';
      case 'NO_CALL_TARGET':
        return 'こちらの応募者は架電対象外です。';
      default:
        return 'こちらの応募者は架電対象外です。';
    }
  }

  // RPM Processing Error (400)
  if (title === 'RPM Processing Error') {
    if (detail?.includes('RPM応募の取得に失敗しました')) {
      return '入力されたIDが見つかりませんでした。IDを確認して再度お試しください。';
    }
    if (detail?.includes('応募の前処理 & 分類に失敗しました')) {
      return '応募情報の処理に失敗しました。しばらく待ってから再度お試しください。';
    }
    return '応募情報の取得に失敗しました。IDを確認して再度お試しください。';
  }

  // Call Request Error (400)
  if (title === 'Call Request Error') {
    return '架電依頼に失敗しました。しばらく待ってから再度お試しください。';
  }

  // Validation Error (400)
  if (title === 'Validation Error') {
    if (validationErrors && validationErrors.length > 0) {
      const firstError = validationErrors[0];
      if (firstError?.path === 'rpmApplicantId') {
        return 'RPM応募者IDを正しく入力してください。';
      }
    }
    return 'RPM応募者IDを正しく入力してください。';
  }

  // 500系エラー (システム側の問題)
  if (
    title === 'RPM API Error' ||
    title === 'RPM Validation Error' ||
    title === 'Upsell Cloud API Error' ||
    title === 'Upsell Cloud Validation Error' ||
    title === 'Internal Server Error'
  ) {
    return '架電依頼に失敗しました。しばらく待ってから再度お試しください。';
  }

  // その他のエラー
  if (detail) {
    // detailに具体的なメッセージがあればそのまま使う（最終手段）
    return detail;
  }

  return '架電依頼に失敗しました。しばらく待ってから再度お試しください。';
};
